import { defineMessages } from 'react-intl';

const messages = defineMessages({
  hideButtons: {
    id: 'hideButtons',
    defaultMessage: 'Hide buttons',
  },
  buttons: {
    id: 'buttons',
    defaultMessage: 'Buttons',
  },
  buttonText: {
    id: 'buttonText',
    defaultMessage: 'Botoiaren testua',
  },
  buttonLink: {
    id: 'buttonLink',
    defaultMessage: 'Botoiaren esteka',
  },
  buttonLinkDescription: {
    id: 'buttonLinkDescription',
    defaultMessage: 'Botoiaren estekak nora bideratuko gaituen.',
  },
  anchorLink: {
    id: 'anchorLink',
    defaultMessage: 'Orrialde bereko esteka (aingura).',
  },
  anchorLinkDescription: {
    id: 'anchorLinkDescription',
    defaultMessage: 'Idatzi # karaktere eta guzti.',
  },
});

export const buttonBlockSchema = (intl) => ({
  title: 'Buttons',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['title', 'href', 'anchor'],
    },
  ],
  properties: {
    title: {
      title: intl.formatMessage(messages.buttonText),
    },
    href: {
      title: intl.formatMessage(messages.buttonLink),
      description: intl.formatMessage(messages.buttonLinkDescription),
      widget: 'object_browser',
      mode: 'link',
      selectedItemAttrs: ['Title', 'Description', '@type', '@id'],
      allowExternals: true,
    },
    anchor: {
      title: intl.formatMessage(messages.anchorLink),
      description: intl.formatMessage(messages.anchorLinkDescription),
    },
  },
  required: [],
});

export const featuredSchemaEnhancer = (props) => {
  const { schema } = props;
  return {
    ...schema,
    fieldsets: [
      {
        ...schema.fieldsets[0],
        fields: [
          ...schema.fieldsets[0].fields,
          'richtitle',
          'description2',
          'preview_image',
          'video',
        ],
      },
    ],
    properties: {
      ...schema.properties,
      richtitle: {
        ...schema.properties.title,
        widget: 'richtext',
      },
      description2: {
        ...schema.properties.description,
      },
      video: {
        title: 'Video',
        widget: 'object_browser',
        mode: 'link',
      },
    },
    // required: [],
  };
};

export const featuredButtonsSchemaEnhancer = (props) => {
  const { intl, schema } = props;
  return {
    ...schema,
    fieldsets: [
      {
        ...schema.fieldsets[0],
        fields: [...schema.fieldsets[0].fields, 'hideButtons', 'buttons'],
      },
    ],
    properties: {
      ...schema.properties,
      hideButtons: {
        title: intl.formatMessage(messages.hideButtons),
        type: 'boolean',
      },
      buttons: {
        title: intl.formatMessage(messages.buttons),
        type: 'panels',
        schema: buttonBlockSchema(intl),
      },
    },
    // required: [],
  };
};
